import { useMemo, useCallback } from "react";
import { useReadContract } from "wagmi";
import { creditsABI } from "../utils/creditsABI";
import { ethers } from "ethers";

const BRAIN_CA = process.env.REACT_APP_BRAIN_CREDITS;

export const ESTIMATE_CREDITS = "estimateCredits";
export const ESTIMATE_PRICE = "estimatePrice";
export const ESTIMATE_TOKEN_AMOUNT = "estimateTokenAmount";
export const CREDITS_PER_PEPECOIN = "creditsPerPepecoin";
export const PEPECOINS_REQUIRED_PER_CREDIT = "pepecoinsRequiredPerCredit";

const formatCredits = (credits) => {
  const numCredits = Number(credits);
  return isNaN(numCredits) ? "0" : parseFloat(numCredits.toFixed(4)).toString();
};

const useContractRead = (functionName) => {
  return useReadContract({
    abi: creditsABI,
    address: BRAIN_CA,
    functionName,
    query: {
      refetchInterval: 2500,
    },
  });
};

export const useMintFrozen = () => {
  const result = useReadContract({
    abi: creditsABI,
    address: BRAIN_CA,
    functionName: "mintingFrozen",
  });

  return result;
};

export const useEstimatePricePerCredit = () => {
  const oneToken = ethers.parseUnits("1", 18);

  const result = useReadContract({
    abi: creditsABI,
    address: BRAIN_CA,
    functionName: ESTIMATE_PRICE,
    args: [oneToken],
    query: {
      refetchInterval: 10000,
    },
  });

  return result;
};

export const useEstimateCreditProceeds = (pepecoinToBurn) => {
  const tokensToBurn = ethers.parseUnits(pepecoinToBurn.toString(), 18);

  const result = useReadContract({
    abi: creditsABI,
    address: BRAIN_CA,
    functionName: ESTIMATE_TOKEN_AMOUNT,
    args: [tokensToBurn],
  });

  return result;
};

export const useEstimateExchangeRate = (pepecoinToBurn = 1) => {
  const tokensToBurn = ethers.parseUnits(pepecoinToBurn.toString(), 18);

  const result = useReadContract({
    abi: creditsABI,
    address: BRAIN_CA,
    functionName: ESTIMATE_TOKEN_AMOUNT,
    args: [tokensToBurn],
  });

  return result;
};

export const useEstimatePrice = (tokenAmount) => {
  return useContractRead({
    abi: creditsABI,
    address: BRAIN_CA,
    functionName: "estimatePrice",
    args: [tokenAmount],
    query: {
      refetchInterval: 2500,
    },
  });
};
